import styles from "./Skills.module.css";
import unityIcon from "../assets/images/skills/Unity.webp";
import csharpIcon from "../assets/images/skills/CSharp.webp";
import gitIcon from "../assets/images/skills/Git.webp";
import blenderIcon from "../assets/images/skills/Blender.webp";
import unrealIcon from "../assets/images/skills/UnrealEngine.webp";
import cppIcon from "../assets/images/skills/CPlusPlus.webp";
import adobeIcon from "../assets/images/skills/AdobeCreativeCloud.webp";
import jsIcon from "../assets/images/skills/JavaScript.webp";
import tsIcon from "../assets/images/skills/TypeScript.webp";
import reactIcon from "../assets/images/skills/React.webp";
import solidityIcon from "../assets/images/skills/Solidity.webp";
import pythonIcon from "../assets/images/skills/Python.webp";
import firebaseIcon from "../assets/images/skills/Firebase.webp";
import awsIcon from "../assets/images/skills/aws.webp";
import xcodeIcon from "../assets/images/skills/Xcode2.webp";
import htmlIcon from "../assets/images/skills/HTML.webp";
import cssIcon from "../assets/images/skills/CSS.webp";
import openaiIcon from "../assets/images/skills/OpenAI.webp";
import vsIcon from "../assets/images/skills/VisualStudio.webp";

const skills = [
  // Programming Languages
  {
    href: "https://learn.microsoft.com/en-us/dotnet/csharp/",
    src: csharpIcon,
    name: "C#",
  },
  { href: "https://isocpp.org/", src: cppIcon, name: "C++" },
  { href: "https://www.python.org/", src: pythonIcon, name: "Python" },
  { href: "https://www.javascript.com/", src: jsIcon, name: "JavaScript" },
  { href: "https://www.typescriptlang.org/", src: tsIcon, name: "TypeScript" },
  { href: "https://soliditylang.org/", src: solidityIcon, name: "Solidity" },

  // Game Engines
  { href: "https://unity.com/", src: unityIcon, name: "Unity" },
  {
    href: "https://www.unrealengine.com/en-US",
    src: unrealIcon,
    name: "Unreal Engine",
  },

  // Web Technologies
  {
    href: "https://html.spec.whatwg.org/multipage/",
    src: htmlIcon,
    name: "HTML",
  },
  {
    href: "https://www.w3.org/Style/CSS/Overview.en.html",
    src: cssIcon,
    name: "CSS",
  },
  { href: "https://react.dev/", src: reactIcon, name: "React" },

  // Tools / Platforms
  { href: "https://git-scm.com/", src: gitIcon, name: "Git" },
  { href: "https://firebase.google.com/", src: firebaseIcon, name: "Firebase" },
  { href: "https://aws.amazon.com/", src: awsIcon, name: "AWS" },
  { href: "https://developer.apple.com/xcode/", src: xcodeIcon, name: "Xcode" },
  {
    href: "https://visualstudio.microsoft.com/",
    src: vsIcon,
    name: "Visual Studio",
  },

  // Creative Tools
  { href: "https://www.blender.org/", src: blenderIcon, name: "Blender" },
  {
    href: "https://www.adobe.com/creativecloud.html",
    src: adobeIcon,
    name: "Adobe Creative Cloud",
  },

  // AI
  { href: "https://openai.com/", src: openaiIcon, name: "OpenAI" },
];

function Skills() {
  return (
    <div className={styles.skills}>
      {skills.map((skill, index) => (
        <a
          key={`${index}-skill`}
          href={skill.href}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.skill}
        >
          <span className={styles.iconWrap}>
            <img src={skill.src} alt={skill.name} />
          </span>
          <span className={styles.skillName}>{skill.name}</span>
        </a>
      ))}
    </div>
  );
}

export default Skills;
